<template>
    <div class="containerBg">
        <div class="shopList">


                <!-- :data="allPrkParkFeeBeanList"  @pulldown="loadData"
                        @loadUp="loadup" :allLoaded="allLoaded" -->
                <scroll :pullup="false" :pulldown="false" :scrollX="true" >
                    <div :class="['listBG',isiOS?'iosMb':'']">

                        <section
                            :class="['package_item',ParkFeeId==item.id?$store.state.common.theme !=3 ?'cur':'cur cur_change':'']"
                            v-for="item in allPrkParkFeeBeanList" :key="item.id"
                            @click="select(item)"
                            >
                            <!-- 是租户且有租户折扣显示折扣图标 -->
                            <img v-if="isUser && item.enableCompanyDiscount == 1" class="discount" src="../../assets/images/discount.png" />
                            <div class="h3div">
                                <span class="h3Span" v-if="item.parkTypeName">{{item.parkTypeName}}</span>
                                <span class="h3Span" v-else>{{item.dayNightType|parkTypeName}}</span>
                            </div>
                            <p v-if="item.dayNightType == 1" class="time_range">24小时</p>
                            <p v-else-if="item.dayNightType == 2" class="time_range">{{parkingMess.dayStartHour}}-{{parkingMess.dayEndHour}}</p>
                            <p v-else-if="item.dayNightType == 3" class="time_range">{{parkingMess.nightStartHour}}-{{parkingMess.nightEndHour}}<span>+1</span></p>
                            <p v-else-if="item.dayNightType == 4" class="time_range">
                              {{item.describe}}
                            </p>
                            <!-- -->
                            <section class="price_box" v-if="!isUser || item.enableCompanyDiscount != 1">
                                <p>{{item.feeStandard}}</p>
                                <span> 元/月</span>
                            </section>
                            <template v-else>
                                <section class="price_box">
                                <p>{{item.companyDiscount.toFixed(2)}}</p>
                                <span> 元/月</span>
                                <p class="underline_text">{{item.feeStandard}}元</p>
                                </section>   
                            </template>

                            

                            <section class="price_box" v-if="item.yearFeeStandard">
                              <p>{{item.yearFeeStandard}}</p>
                              <span>元/年</span>
                            </section>
                            <img v-if="item.dayNightType == 1" class="icon_t" src="../../assets/images/parking/icon_all_day.png">
                            <img v-else-if="item.dayNightType == 2" class="icon_t" src="../../assets/images/parking/icon_daytime.png">
                            <img v-else-if="item.dayNightType == 3" class="icon_t" src="../../assets/images/parking/icon_night.png">
                            <img v-if="dayNightType == item.dayNightType&&$store.state.common.theme !=3" class="icon_select" src="../../assets/images/selected.png">
                            <img v-if="dayNightType == item.dayNightType&&$store.state.common.theme ==3" class="icon_select" src="../../assets/images/parking/selected_3.png">
                            
                        </section>

                    </div>
                </scroll>
         </div>
         <div class="footButton" >
          <div :class="$store.state.common.theme !=3 ? 'parkingDiscountfootButton2_div' :'parkingDiscountfootButton2_div_3'" @click="doAction()">
               <span class="parkingDiscountfootButton_Span">确定</span>
          </div>
      </div>

    </div>
</template>
<script>
import util from "@/utils/util";
import {mapState} from 'vuex';
import Scroll from "../../components/scroll";
import storage from '../../utils/storage';
export default {
      computed: {
        ...mapState({
            common: state => state.common
        }),
      },
      components: {
        Scroll,
      },
      filters:{
        parkTypeName(val){
          if(val == 1){
              return '全天'
          }else if(val == 2){
              return '日间'
          }else if(val == 3){
              return '夜间'
          }else{
              return '自定义';
          }
        }
     },
      data(){
        return {
            isLoad:false,
            dayNightType:'',
            parkingMess:'',
            allPrkParkFeeBeanList:'',
            selectItem:'',
            isUser:true,
            allLoaded:true,
            ParkFeeId:'',
        }
    },
     created() {
         this.dayNightType =  this.$route.query.dayNightType;
         //this.isiOS = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
         this.isiOS =false;
         var isUser = this.$route.query.isUser;
         if(isUser == '0'){
          this.isUser =false;
         }else{
          this.isUser =true;
         }
        
         console.log("isUser ====   " +  this.isUser);
         this.ParkFeeId =this.$route.query.ParkFeeId;
         this.parkingMess = JSON.parse(storage.getS("FeeListparkingMess"));
         this.allPrkParkFeeBeanList = JSON.parse(storage.getS("allPrkParkFeeBeanList"));
         console.log("this.allPrkParkFeeBeanList ====   " +JSON.stringify(this.allPrkParkFeeBeanList))
        //  for(var i=0;i<20;i++){
        //      this.allPrkParkFeeBeanList.push(this.allPrkParkFeeBeanList[0]);
        //  }
         //JSON.parse(storage.get("allPrkParkFeeBeanList"))
        // console.log("this.allPrkParkFeeBeanList ====   " +JSON.stringify(this.allPrkParkFeeBeanList))
     },
    mounted(){

    },
    methods:{
        select(item){
            this.selectItem=item;
            this.ParkFeeId =item.id;
            this.dayNightType =item.dayNightType;
        },

        //上拉
        loadup(){
        },

        //下拉刷新
        loadData(){
        },
        doAction(){
            storage.setS("ParkFeeSelectItem",JSON.stringify(this.selectItem) )
            this.$router.go(-1)
        },
    }

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.containerBg{
    background:#FFFFFF;
    height: 100vh;
    .flex(column);
    .shopList{
         flex: 1;
         height: 500px;
          background:#FFFFFF;
          margin-bottom: 108px;
    }
};

.scbg{
    flex-direction: column;
    width: 100%;
   // margin-bottom: 208px;
    background: #ffffff;
};

.listBG{
  background:#ffffff;
//   flex: 1;
//   height: 500px;
  margin-top: 20px;
  margin-left: 13px;
  margin-bottom: 208px;
  width: 100%;
  flex-wrap: wrap;
  .flex();
  .package_item{
    width:696px;
    // height:300px;
    margin:0 7px;
    padding-left:16px;
    margin-bottom: 20px;
    // height:176px;
    border-radius:8px;
    border:4px solid rgba(239,239,239,1);
    box-sizing: border-box;
    position: relative;
    background:rgba(248,248,248,1);
    .discount{
      position:relative;
      left:-20px;top:-4px;
      width:132px;height:40px;
    }
    .img_h{
      height:40px;
    }
    .underline_text{
      text-decoration:line-through;
      font-size:24px;
      color:#999;
      margin-bottom:20px;
    }
    .h3div{
        width: 380px;
        display: flex;
        .h3Span{
            font-size:28px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            line-height:34px;
            //   height: 80px;
            width: 380px;
            margin-top:16px;
            margin-bottom:10px;
        // white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            lines:2;
            max-lines: 2;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
    .time_range{
      white-space: nowrap;
      height:32px;
      font-size:24px;
      color:rgba(102,102,102,1);
      line-height:32px;
      margin-bottom:14px;
      span{
        font-size:20px;
        color:#16BC84;
      }
    }
    .price_box{
      .flex();
      align-items: flex-end;
      margin-bottom:12px;
      p{
        font-size:44px;
        color:rgba(252,63,86,1);
        margin-right:4px;
      }
      span{
        font-size:26px;
        color:rgba(51,51,51,1);
        line-height:36px;
      }
      .underline_text {
        text-decoration: line-through;
        font-size: 24px;
        color: #999;
        margin-left: 10px;
        margin-bottom: 5px;
      }
    }
    .icon_t{
      position:absolute;
      top:20px;right:24px;
      width:28px;height:28px;
    }
    .icon_select{
      position:absolute;
      bottom:-2px;right:-3px;
      width:36px;height:36px;
      display:none;
    }
  }
  .cur{
    background:rgba(246,248,254,1);
    border:4px solid rgba(23,64,218,1);
    .icon_select{
      display: block;
    }
  }
  .cur_change{
    border: 4px solid #A1805D;
  }
  .package_item_one{
    width:348px;
    flex:0 1 auto;
  }
}
.iosMb{
    margin-bottom: 218px;
}

.foot{
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    height: 108px;
    background-color: #ffffff;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.bill_foot_button{
  flex-direction: row;
  margin-left: 28px;
  display: flex;
  width:694px;
  height:76px;
//   background:rgba(23,64,218,1);
  border-radius:4px;
}
.foot_span4{

    width:694px;
    height:76px;
    display: block;
    text-align: center;
    background:rgba(23,64,218,1);
    border-radius:4px;
    font-size:32px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height: 76px;

}
.footButton{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    height: 112px;
    box-sizing:border-box;
    display: flex;
    background-color: white;
    flex-direction: row;
    justify-content: space-between;
}
.parkingDiscountfootButton2_div{
    margin-top: 18px;
    margin-left: 20px;
    width:710px;
    height: 76px;
    border-radius:4px;
    display: flex;
     justify-content: center;
    align-items: center;
    background-color: #1740DA;

}
.parkingDiscountfootButton_Span{
    font-size:32px;
    font-weight:400;
    color:#FFFFFF;
    line-height:44px;
}
.parkingDiscountfootButton2_div_3{
  margin-top: 18px;
    margin-left: 20px;
    width:710px;
    height: 76px;
    border-radius:4px;
    display: flex;
     justify-content: center;
    align-items: center;
  background-color: #A1805D;
}

</style>